// import { Component } from '@angular/core';
// import Gleap from 'gleap';
// Gleap.initialize("nLTao49nVlJMj1nVYIgbg74IgZi9lM9T");

// @Component({
//     selector   : 'app-root',
//     templateUrl: './app.moduleId.html',
//     styleUrls  : ['./app.moduleId.scss']
// })
export const myData = {

moduleId: "",
filingtype : 0,
datefrom : new Date,
dateto : new Date,
bypass: false,
dropdownBypass: false,
backSave: false,
id : "",
stepperIndex: 0,
payrollCode: "",
};
